import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-checked", "aria-disabled", "tabindex"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "el-radio__inner" }, null, -1)
const _hoisted_3 = ["value", "name", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["el-radio", {
      [`el-radio--${_ctx.radioSize || ''}`]: _ctx.border && _ctx.radioSize,
      'is-disabled': _ctx.isDisabled,
      'is-focus': _ctx.focus,
      'is-bordered': _ctx.border,
      'is-checked': _ctx.model === _ctx.label
    }]),
    role: "radio",
    "aria-checked": _ctx.model === _ctx.label,
    "aria-disabled": _ctx.isDisabled,
    tabindex: _ctx.tabIndex,
    onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.model = _ctx.isDisabled ? _ctx.model : _ctx.label), ["stop","prevent"]), ["space"]))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["el-radio__input", {
        'is-disabled': _ctx.isDisabled,
        'is-checked': _ctx.model === _ctx.label
      }])
    }, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        ref: "radioRef",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
        class: "el-radio__original",
        value: _ctx.label,
        type: "radio",
        "aria-hidden": "true",
        name: _ctx.name,
        disabled: _ctx.isDisabled,
        tabindex: "-1",
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focus = true)),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focus = false)),
        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
      }, null, 40, _hoisted_3), [
        [_vModelRadio, _ctx.model]
      ])
    ], 2),
    _createElementVNode("span", {
      class: "el-radio__label body",
      onKeydown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ])
    ], 32)
  ], 42, _hoisted_1))
}